import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPackageAdd"><Path d="M12.5 20.5H3.5V3.5H8.5M8.5 3.5H15.5M8.5 3.5V9.5H15.5V3.5M15.5 3.5H20.5V11.5M18.5 14.5V17.5M18.5 17.5V20.5M18.5 17.5H15.5M18.5 17.5H21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPackageAdd;
